module.exports = __webpack_public_path__ + "assets/webgl/wp_concrete_01b2_color.jpg.03b5d98c.webp";